import { render, staticRenderFns } from "./live3.vue?vue&type=template&id=6b043305&scoped=true"
import script from "./live3.vue?vue&type=script&lang=js"
export * from "./live3.vue?vue&type=script&lang=js"
import style0 from "./live3.vue?vue&type=style&index=0&id=6b043305&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b043305",
  null
  
)

export default component.exports